import { render, staticRenderFns } from "./JvmInfo.vue?vue&type=template&id=1cc28dd0&"
import script from "./JvmInfo.vue?vue&type=script&lang=js&"
export * from "./JvmInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports